export default "__VITE_ASSET__7ylBZ5LI__"